import ManagerDiscoveryReview from './ManagerDiscoveryReview.container';

export default ManagerDiscoveryReview;
